export const validEmail = new RegExp(
  "^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$"
);
export const validPhone = new RegExp("^\\(?(\\+\\d{1,2})?\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{3}[\\s.-]?\\d{4}$");
export const hasvalue = new RegExp(".+");
